export const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;

export const wait = (ms: number) =>
  new Promise(resolve => setTimeout(resolve, ms));

export const saveAsFile = (data: unknown, fileName: string): void => {
  const a = document.createElement('a');
  const json = JSON.stringify(data, null, '  ');
  const blob = new Blob([json], { type: 'text/plain' });
  a.href = URL.createObjectURL(blob);
  a.download = fileName;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  a.remove();
};

export function getBlobUrlFromB64Url(b64Url: string): string {
  const [, mimeType, data] = orDie(b64Url.match(/^data:(.*?);base64,(.*)$/));
  const binary = atob(data);
  const len = binary.length;
  const bytes = new Uint8Array(len);

  for (let i = 0; i < len; ++i) {
    bytes[i] = binary.charCodeAt(i);
  }

  const blob = new Blob([bytes], { type: mimeType });
  return URL.createObjectURL(blob);
}

export function arrayBufferToBase64(arrayBuffer: ArrayBuffer): string {
  const bytes = new Uint8Array(arrayBuffer);
  let binary = '';

  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }

  return btoa(binary); // Convert binary string to Base64
}

export async function pngToJpeg(
  file: File,
  maxWidth: number,
  maxHeight: number
): Promise<File> {
  return new Promise<File>((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = function (event) {
      const img = new Image();

      img.onload = function () {
        let width = img.naturalWidth;
        let height = img.naturalHeight;

        if (width > maxWidth || height > maxHeight) {
          const aspectRatio = width / height;
          if (width > height) {
            width = maxWidth;
            height = Math.round(maxWidth / aspectRatio);
          } else {
            height = maxHeight;
            width = Math.round(maxHeight * aspectRatio);
          }
        }

        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;

        const ctx = orDie(canvas.getContext('2d'));
        ctx.drawImage(img, 0, 0, width, height);

        // Convert canvas to JPEG Blob
        canvas.toBlob(
          blob => {
            resolve(
              new File([orDie(blob)], 'compress.jpg', {
                type: 'image/jpeg',
              })
            );
          },
          'image/jpeg',
          0.85 // JPEG quality (0.0 - 1.0)
        );
      };

      img.onerror = () => reject(new Error('Failed to load image'));
      img.src = event.target?.result as string;
    };

    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.readAsDataURL(file);
  });
}

export function doubleConfirm(): boolean {
  return confirm('Are you sure?') && confirm(`Once again? It's irreversible!`);
}

export const isAbortError = (error: unknown): boolean =>
  error instanceof Error && error.name === 'AbortError';

// <audio/>.play() throws it if there was no yet an interaction with the page.
export const isNotAllowedError = (error: unknown): boolean =>
  error instanceof Error && error.name === 'NotAllowedError';
